import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import LoginForm from "../../components/admin/LoginForm";
import useAuthStore from "../../store/authStore";
import styles from "./LoginPage.module.css";
import { getAdminHomePath, isAdminWebRole } from "../../utils/adminAccess";

function LoginPage() {
  const navigate = useNavigate();
  const login = useAuthStore((state) => state.login);
  const [error, setError] = useState("");

  const handleLogin = async (email, password) => {
    const credentials = {
      emailOrPhone: email,
      password: password,
    };

    try {
      let authResult = null;
      let loginError = null;
      let authenticatedButDenied = false;
      const loginTargets = [undefined, "dream"];

      for (const service of loginTargets) {
        try {
          const response = await api.post("/auth/login", credentials, service ? { params: { service } } : undefined);
          authResult = response.data;

          if (isAdminWebRole(authResult.user)) {
            break;
          }

          authenticatedButDenied = true;
        } catch (err) {
          loginError = err;
        }
      }

      if (authResult?.user && isAdminWebRole(authResult.user)) {
        login(authResult);
        navigate(getAdminHomePath(authResult.user));
      } else if (authenticatedButDenied) {
        setError("관리자 또는 협력업체 계정만 로그인할 수 있습니다.");
      } else {
        throw loginError;
      }
    } catch (err) {
      setError("이메일 또는 비밀번호가 올바르지 않습니다.");
      console.error("Login failed:", err);
    }
  };

  return (
    <div className={styles.pageContainer}>
      <LoginForm onSubmit={handleLogin} error={error} />
    </div>
  );
}

export default LoginPage;
